import React, {useEffect, useState} from "react";
import {Dialog, DialogContent, IconButton} from "@mui/material";
import {ArrowBack, ArrowForward, Close} from "@mui/icons-material";

interface ImageDialogProps {
    open: boolean;
    onClose?: () => void;
    images: string[];
    activeImageIndex: number;
}

const ImageDialog: React.FC<ImageDialogProps> = ({open, onClose, images, activeImageIndex}) => {
    const [currentIndex, setCurrentIndex] = useState(activeImageIndex);

    useEffect(() => {
        setCurrentIndex(activeImageIndex);
    }, [activeImageIndex]);

    const handleNext = () => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
    };

    const handlePrev = () => {
        setCurrentIndex((prevIndex) => (prevIndex - 1 + images.length) % images.length);
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="md">
            <DialogContent sx={{position: "relative", textAlign: "center", p: 2}}>
                <IconButton
                    onClick={onClose}
                    sx={{position: "absolute", top: 10, right: 10, color: "white", background: "rgba(0,0,0,0.5)"}}
                >
                    <Close />
                </IconButton>

                <img
                    src={images[currentIndex]}
                    alt={`Image ${currentIndex + 1}`}
                    style={{maxWidth: "100%", maxHeight: "80vh", borderRadius: 8}}
                />

                {images.length > 1 && (
                    <>
                        <IconButton
                            onClick={handlePrev}
                            sx={{
                                position: "absolute",
                                top: "50%",
                                left: 10,
                                transform: "translateY(-50%)",
                                color: "white",
                                background: "rgba(0,0,0,0.5)",
                            }}
                        >
                            <ArrowBack />
                        </IconButton>

                        <IconButton
                            onClick={handleNext}
                            sx={{
                                position: "absolute",
                                top: "50%",
                                right: 10,
                                transform: "translateY(-50%)",
                                color: "white",
                                background: "rgba(0,0,0,0.5)",
                            }}
                        >
                            <ArrowForward />
                        </IconButton>
                    </>
                )}
            </DialogContent>
        </Dialog>
    );
};

export default ImageDialog;
